import {Playlists} from '../components'
import {MyPlaylist} from '../components/Playlist'
import {useMyPlaylists} from '../hooks/useMyPlaylists'
import {useSelectPlaylists} from '../hooks/useSelectPlaylists'

export const MyPlaylists = ({
  userId,
  selected,
  addPlaylist,
  removePlaylist
}: {userId: string} & ReturnType<typeof useSelectPlaylists>) => {
  const [playlists] = useMyPlaylists(userId)
  return (
    <Playlists>
      {playlists.map(playlist => {
        return (
          <MyPlaylist
            size="large"
            key={playlist.id}
            playlist={playlist}
            selected={selected.includes(playlist.id)}
            onSelect={(p, checked) => {
              checked ? addPlaylist(p.id) : removePlaylist(p.id)
            }}
          />
        )
      })}
    </Playlists>
  )
}
